<template>
  <div >
    <h2 class="card-inside-title">{{dropdownSource.label}} ({{dropdownSource.keys}}) <small>{{optionalOrNot(dropdownSource.required)}}</small></h2>

    <select
        class="form-control show-tick"
        v-model="$store.state.workflowStore.workflowsS[actionCount].api.design.forms[indexs].value"

    >
      <option :value="''">-- 선택 --</option>
      <option
          v-for="(app, index) in form"
          :key="index"
          :value="app.name"

      >
        {{ app.label }}
      </option>
    </select>








<!--    <input-->
<!--        type="text"-->
<!--        class="form-control"-->
<!--        :placeholder="form.label"-->
<!--        :name="form.keys"-->
<!--        v-model="-->
<!--                                $store.state.workflowStore.workflowsS[0].api.design.forms[indexs].value-->
<!--                              "-->
<!--    />-->
  </div>

</template>

<script>
export default {
  props : ['dropdownSource', 'selectAuth','actionCount', 'indexs'],
  data() {
    return{
      form : [],
    }
  },
  computed: {
    workflowStore() {
      return this.$store.state.workflowStore;
    },
    userStore() {
      return this.$store.state.userStore;
    },
  },


  methods: {

    optionalOrNot(val){
      if(val == 0){
        return "선택"
      } else {
        return "필수"
      }
    },






  },
  created(){
    console.log("userEditorDropdownSource.created")

    console.log(this.dropdownSource)
    console.log(this.$store.state.workflowStore.workflowsS[this.actionCount])

    if(this.dropdownSource.dropdown == 1){

      if(this.dropdownSource.dropdownSource.source != "" && this.dropdownSource.dropdownSource.source != null){

        var appCode = this.$store.state.workflowStore.workflowsS[this.actionCount].api.appCode
        var versionCode = this.$store.state.workflowStore.workflowsS[this.actionCount].api.versionCode
        var authInfo = this.$store.state.workflowStore.workflowsS[this.actionCount].authentication
        // var fieldData = this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.
        // var workflowCode = this.$store.state.workflowStore.workflowCode


        var apiCode = this.dropdownSource.dropdownSource.source

        var param = {

          appCode : appCode,
          apiCode : apiCode,
          versionCode : versionCode,
          authInfo : JSON.stringify(authInfo),
          fieldData : JSON.stringify(this.dropdownSource),
          // workIndex : this.actionCount,
          // workflowCode : workflowCode,

        }

        this.api.dropdownApi(param)
        .then((res)=>{
          console.log("결과창 g확인: ", res)

          this.form = JSON.parse(res.result)

        })


      }


    }


    // var flowData = this.$store.state.workflowStore.workflowsS[this.actionCount].api.design.forms[this.multiFormIndex]
    //
    // this.apiSetting.key = flowData.keys
    // this.apiSetting.label = flowData.label
    // this.apiSetting.multibox = ''
    //
    //
    //
    // if(flowData.multi == 1){
    //
    //   if(flowData.value != undefined || flowData.value != ''){
    //     var datas = flowData.value.split(",")
    //     for(var i = 0; i < datas.length; i++){
    //
    //       this.tagVal.push(datas[i])
    //
    //     }
    //
    //   }
    // }





  }
};
</script>


